/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.svg';
import Container from '../../shared/Container';
import Spacer from '../../shared/Spacer';
import call from '../../../assets/images/call.svg';
import mail from '../../../assets/images/mail.svg';
import linkedin from '../../../assets/images/linkedin.svg';

const Logo = styled.div`
  width: 150px;
  @media (max-width: 425px) {
    width: 100px;
  }
  img {
    width: 100%;
  }
`;

const Flexbox = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  p {
    text-align: center;
  }
  @media (max-width: 425px) {
    margin-top: 50px;
  }
`;

const Navigation = styled.ul`
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 0;
  padding: 0;
  flex-wrap: wrap;
  @media (max-width: 425px) {
    font-size: 16px;
  }
`;

const NavItem = styled.li`
  margin: 0 15px;
  a {
    color: #fff;
    font-family: 'gothambold';
    text-decoration: none;
    &:hover,
    &:focus {
      outline: none;
      text-decoration: underline;
    }
  }
  &:first-child {
    list-style: none;
    margin: 0 15px 0 0;
  }
  &:last-child {
    margin: 0 0 0 15px;
  }
`;

const Social = styled.ul`
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  list-style: none;
  padding: 0;
  flex-wrap: wrap;
`;
const SocialItem = styled.li`
  margin: 0 20px;
  transition: transform 200ms;
  padding: 15px;
  &:hover {
    cursor: pointer;
    transform: translateY(-5px);
  }
`;

const Footer = () => (
  <Container>
    <Flexbox>
      <Logo>
        <img src={logo} alt="ZOI" />
      </Logo>
      <Navigation>
        <NavItem>
          <Link to="/">Homes</Link>
        </NavItem>
        <NavItem>
          <Link to="/hostel">Hostel</Link>
        </NavItem>
        <NavItem>
          <Link to="/ngo">NGO</Link>
        </NavItem>
      </Navigation>
      <p>Just making people, more humane...</p>
      <Social>
        <SocialItem>
          <a
            href="https://in.linkedin.com/company/zoihomes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="Youtube" />
          </a>
        </SocialItem>
        <SocialItem>
          <a href="mailto:pjprakhar1998@gmail.com">
            <img src={mail} alt="Mail" />
          </a>
        </SocialItem>
        <SocialItem>
          <a href="tel:+918112262682">
            <img src={call} alt="call" />
          </a>
        </SocialItem>
      </Social>
      <p>COPYRIGHT @ ZOI HOMES</p>
    </Flexbox>

    <Spacer marginBottom="60px" />
  </Container>
);

export default Footer;
